import { type Component, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { CircleDot, Layers, Sparkles, Square, Star, Trophy, Volleyball, Zap } from 'lucide-solid';

const ICONS: Record<string, typeof Sparkles> = {
  Sparkles,
  Trophy,
  CircleDot,
  Volleyball,
  Square,
  Layers,
  Star,
  Zap,
};
export const sportIconComponent = (name: string | undefined) =>
  ICONS[name ?? 'Sparkles'] ?? Sparkles;


const isEmojiIcon = (icon: string | undefined): icon is string =>
  !!icon && /[^\x00-\x7F]/.test(icon);

export const SportIconRenderer: Component<{
  icon: string | undefined;
  class?: string;
  emojiSize?: number;
}> = (props) => {
  return (
    <Show
      when={isEmojiIcon(props.icon)}
      fallback={
        <Dynamic
          component={sportIconComponent(props.icon)}
          class={props.class ?? 'h-4 w-4'}
        />
      }
    >
      <span
        aria-hidden="true"
        style={{
          'font-size': `${props.emojiSize ?? 16}px`,
          'line-height': 1,
          'font-family':
            '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif',
        }}
      >
        {props.icon}
      </span>
    </Show>
  );
};
